import React from "react";

const ErrorPage = () => <div className="text-center mt-5">ERROR - Please try again later.</div>;

export default ErrorPage;
